<h2 mat-dialog-title>Import employees</h2>

<mat-dialog-content class="v2-dialog">
  <p class="v2-dialog-hint import-intro">
    Upload an Excel file with two columns, <strong>Name</strong> and <strong>Email</strong>.
    <a href="javascript:void(0)" (click)="downloadTemplate()">Download template</a>
  </p>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Add everyone to group</mat-label>
    <mat-select [(ngModel)]="groupId" required [disabled]="running || finished">
      <mat-option *ngFor="let g of data.groups" [value]="g.groupId">{{ g.name }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="v2-dialog-checks">
    <mat-checkbox [(ngModel)]="sendInvite" [disabled]="running || finished"
      matTooltip="Emails each employee a link where they set their own password">Send welcome email</mat-checkbox>
  </div>

  <div class="import-file">
    <input #fileInput type="file" accept=".xlsx,.xls,.csv" hidden (change)="onFile($event)">
    <button mat-stroked-button type="button" [disabled]="running" (click)="fileInput.click()">
      <mat-icon>upload_file</mat-icon> Choose file
    </button>
    <span class="import-file-name">{{ fileName || 'No file chosen' }}</span>
  </div>
  <p class="import-error" *ngIf="fileError">{{ fileError }}</p>

  <p class="v2-dialog-hint" *ngIf="rows.length && !groupId && !finished">Choose the group to add them to.</p>

  <ng-container *ngIf="rows.length">
    <p class="import-summary">
      <ng-container *ngIf="!finished && !running">{{ ready }} ready to import<span *ngIf="skipped">, {{ skipped }} skipped</span></ng-container>
      <ng-container *ngIf="running">Importing {{ done }} of {{ total }}…</ng-container>
      <ng-container *ngIf="finished">{{ added }} added<span *ngIf="failed">, {{ failed }} failed</span><span *ngIf="skipped">, {{ skipped }} skipped</span></ng-container>
    </p>
    <div class="import-table-wrap">
      <table class="import-table">
        <tr><th>Row</th><th>Name</th><th>Email</th><th>Result</th></tr>
        <tr *ngFor="let r of rows" [class]="'is-' + r.status">
          <td>{{ r.line }}</td>
          <td>{{ r.name }}</td>
          <td>{{ r.email }}</td>
          <td>
            <span *ngIf="r.status === 'ready'">Ready</span>
            <span *ngIf="r.status === 'importing'">Importing…</span>
            <span *ngIf="r.status !== 'ready' && r.status !== 'importing'">{{ r.note }}</span>
          </td>
        </tr>
      </table>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [disabled]="running" (click)="close()">{{ finished ? 'Close' : 'Cancel' }}</button>
  <button mat-flat-button color="primary" *ngIf="!finished" [disabled]="running || !ready || !groupId" (click)="import()">
    Import {{ ready || '' }}
  </button>
</mat-dialog-actions>
